import {
  totalPages,
  calculateTotalPages,
  currentActivePage
} from "./pagination";
import { ref } from "vue";

const keyword = ref("" as string);
const keywordInput = ref("" as string);

const updateYearClear = () => {
  keyword.value = "";
  keywordInput.value = "";
  currentActivePage.value = 1;
};

const updateKeyword = () => {
  keywordInput.value = keyword.value;
};

const clearKeyword = () => {
  keywordInput.value = "";
  keyword.value = "";
};

const resourcesChanged = (update, pageSize: number) => {
  currentActivePage.value = update.currentPage;
  const total = update.totalResults !== undefined ? update.totalResults : 0;
  totalPages.value = calculateTotalPages(total, pageSize);
};

export {
  resourcesChanged,
  clearKeyword,
  updateKeyword,
  updateYearClear,
  keywordInput,
  keyword
};
